import { Outlet } from 'react-router'

const PPCDataLayout = () => {
  return (
    <Outlet />
  )
}

export default PPCDataLayout